import { render, staticRenderFns } from "./MessageMain.vue?vue&type=template&id=3e17b868&"
import script from "./MessageMain.vue?vue&type=script&lang=js&"
export * from "./MessageMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports